export const camelToKebab = (str: string): string =>
  str.replace(
    /[A-Z]+(?![^A-Z])|[A-Z]/g,
    (a, b) => (b ? '-' : '') + a.toLowerCase(),
  );
